import React, { useState, useMemo } from "react";
import { Droppable } from "react-beautiful-dnd";

import { useCustomSearchParams } from "../../hooks/useCustomSearchParams";
import CreateCard from "../../pages/board/components/Kanban/CreateCard";
import TodoSteps from "./TodoSteps";
import { useResponsive } from "../../hooks/useResponsive";

const Column = React.memo(
  ({
    name,
    stage,
    cards,
    height,
    maxHeight,
    isCreateCardFieldOpen,
    handleCreateCardClick,
    boardName,
  }) => {
    const [milestone] = useCustomSearchParams("milestone");
    const isMobile = useResponsive("down", "md");
    const [scrollToCardId, setScrollToCardId] = useState(null);

    return (
      <div
        className={`card-column todo-column ${
          isMobile ? "mobile-quick-task" : ""
        }`}
      >
        <div className="card-column-container">
          {!isMobile && (
            <div className="coloumn-header todo-column-header">
              <h4 className="coloumn-header-h4">
                <p className="coloumn-header-text">{name}</p>
              </h4>
            </div>
          )}
          <div
            className={`todo-column-body ${
              isMobile
                ? "mobile-todo-column-body"
                : `coloumn-body${
                    maxHeight > 0 && maxHeight < 4 ? `-${maxHeight}` : ""
                  }`
            } `}
          >
            <Droppable droppableId={"todo-column"}>
              {(provided) => (
                <div
                  className="coloumn-all-cards"
                  style={{
                    height: `${
                      isMobile
                        ? "auto"
                        : `calc(94vh - ${milestone ? "340px" : `${height}px`} )`
                    }`,
                  }}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <div className={isMobile ? "width-100" : ""}>
                    <CreateCard
                      stage={stage}
                      isTodo={true}
                      newCreatedCardId={setScrollToCardId}
                      isCreateCardFieldOpen={isCreateCardFieldOpen}
                      handleCreateCardClick={handleCreateCardClick}
                      boardName={boardName}
                    />
                  </div>
                  <TodoSteps
                    cards={cards}
                    scrollToCardId={scrollToCardId}
                    height={height}
                  />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        </div>
      </div>
    );
  }
);

export default Column;
